import useTranslation from 'next-translate/useTranslation'
import { FC } from 'react'
import { Button, Stack } from 'rsuite'
import { Crisp } from 'crisp-sdk-web'

import ChatIcon from '../../Icons/ChatIcon'

import styles from '../../../styles/ChatBanner.module.less'

const ChatBanner: FC = () => {
  const { t } = useTranslation('modals')

  const handleChatClick = () => {
    Crisp.chat.open()
  }

  return (
    <Stack
      direction="column"
      className={styles['chat-banner']}
    >
      <ChatIcon />

      <p className="h3 margin-bottom-spacer margin-top-spacer">
        {t('modals:Need help?')}
      </p>

      <p className={styles.subtitle}>
        {t('modals:Get help from our experts')}
      </p>

      <Button
        appearance="primary"
        className="margin-bottom-spacer-tripple margin-top-spacer"
        onClick={handleChatClick}
      >
        {t('modals:Chat with us')}
      </Button>
    </Stack>
  )
}

export default ChatBanner
